import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface CommentInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  maxLength?: number;
}

export function CommentInput({ value, onChange, disabled, maxLength = 256 }: CommentInputProps) {
  const { t } = useTranslation();
  return (
    <div className="grid gap-2">
      <Label htmlFor="comment">{t('receive.comments.label')}</Label>
      <Textarea
        id="comment"
        placeholder={t('email.onlinesrf.comments')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={3}
        disabled={disabled}
        maxLength={maxLength}
      />
      <p className="text-xs text-muted-foreground">
        {t('onlinesrf.attachment.characters', { length: value.length, maxLength })}
      </p>
    </div>
  );
}
